import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export function usePageTitle(
  titleString: string,
  shouldTranslate: boolean = true
): void {
  const { t } = useTranslation();
  const suffix = t("aic_app_page_title_text");

  let pageTitle = titleString;

  if (shouldTranslate) {
    pageTitle = t(titleString);
  }

  const title = [pageTitle, suffix].filter((t) => t.length).join(" | ");

  useEffect(() => {
    // do not use document.title directly to avoid overwrite VC title
    const element = document.querySelector("#app-title") as HTMLElement;
    if (element) {
      element.textContent = title;
    }
  }, [title]);
}
